import { z } from "zod";
import { noAnswerSchema, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  level: z.union([z.literal(1), z.literal(2), z.literal(3)]).default(2),
  align: z.enum(["left", "center"]).default("left"),
});

export const headingField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "heading",
  label: "Heading",
  category: "layout",
  icon: "Heading",
  configSchema,
  valueSchema: () => noAnswerSchema(),
  defaultConfig: { level: 2, align: "left" },
  supportsProfileBinding: false,
  defaultSearchable: false,
  renderHints: { isLayoutOnly: true },
};
